var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiCard',[_c('UiNavigationBar',{attrs:{"bleed":"","title":_vm.$t('general.bookmarks'),"responsive":""},on:{"back":function($event){return _vm.$router.go(-1)}}}),_c('UiPosts',{attrs:{"layout":"grid","sizes":{ initial: '30vw', lg: '18vw', xl: '21vw' }},model:{value:(_vm.posts),callback:function ($$v) {_vm.posts=$$v},expression:"posts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }